// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-numeric-editor{display:grid;height:100%}.ag-numeric-editor input{min-width:0}`, "",{"version":3,"sources":["webpack://./src/agElements/editors/agNumericEditor.scss"],"names":[],"mappings":"AAAA,mBAAmB,YAAY,CAAC,WAAW,CAAC,yBAAyB,WAAW","sourcesContent":[".ag-numeric-editor{display:grid;height:100%}.ag-numeric-editor input{min-width:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
